import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Upload, GetProp, UploadProps, UploadFile } from 'antd';
import { CouponService } from "./../../services/CouponService";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';
import moment from 'moment';
import dayjs from 'dayjs';
import { RewardService } from '../../services/RewardService';
import Editor from '../../components/ckeditor/Editor';
import {
    UploadOutlined
} from "@ant-design/icons";
// import 'ckeditor5/ckeditor5.css';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, List } from 'ckeditor5';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];


interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();
    const [categories, setCategories] = React.useState([])
    const [details, setDetails] = React.useState<string>("")
    const [file, setFile] = React.useState<any>();
    const [fileList, setFileList] = React.useState<any>([]);


    // const handleFileChange = (info: any) => {
    //     const uploadedFile = info.file;
    //     setFile(uploadedFile);
       
    // };

    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
            'start_date': props?.record?.start_date && moment(props?.record?.start_date).isValid() ? dayjs(props?.record?.start_date) : undefined,
            'expired_date': props?.record?.expired_date && moment(props?.record?.expired_date).isValid() ? dayjs(props?.record?.expired_date) : undefined
        })
        setDetails(props?.record?.details)

        getCategories();
    }, [props?.record])

    const getCategories = async () => {
        const res = await RewardService.getCategories({
            page: 1,
            perPage: 10
        });
        console.log(res.data)
        setCategories(res.data.map((item: any) => {
            return {
                label: item.name_en,
                value: item.id
            }
        }))
    }


    const onFinish: FormProps["onFinish"] = async (values) => {

        const formData = new FormData();
        if (values.reward_category_id) {
            formData.append('reward_category_id', values.reward_category_id);
        }
        formData.append('name', values.name);
        formData.append('point', values.point);
        formData.append('details', values.details);
        formData.append('is_public', values.is_public ? "1" : "0");
        formData.append('is_super_deal', values.is_super_deal ? "1" : "0");
        if(file){
            formData.append('coupon', file);
        }
        

        if (values.start_date) {
            formData.append('start_date', moment(new Date(values.start_date)).format('YYYY-MM-DD HH:mm:ss'));
        }
        if (values.expired_date) {
            formData.append('expired_date', moment(new Date(values.expired_date)).format('YYYY-MM-DD HH:mm:ss'));
        }




        if (props?.record?.id) {
            var res = await CouponService.updateCoupon(formData, props.record.id)
        } else {
            var res = await CouponService.saveCoupon(formData)

        }

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };



    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    reward_category_id: null,
                    name: '',
                    details: '',
                    point: 0,
                    expired_date: null,
                    start_date: null,
                    is_public: 0,
                    is_super_deal: 0
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Category"
                    name="reward_category_id"
                    rules={[{ required: true, message: 'Please select category' }]}
                    // rules={[
                    //     ({ getFieldValue }) => ({
                    //         validator(_, value) {
                    //             if (value === null || value === undefined || value === '') {
                    //                 return Promise.resolve(); // Allow null
                    //             }
                    //             return Promise.resolve(); // Allow valid values
                    //         },
                    //     }),
                    // ]}

                >
                    <Select
                    
                        placeholder="Please select category"
                        allowClear
                        // allowClear={{ clearIcon: ClearOutlined }}  // Optional custom clear icon
                        options={[
                            ...categories
                        ]}
                        disabled={false}
                        onSelect={(value, option: any) => {


                        }}
                    />


                </Form.Item>




                <Form.Item
                    label="Coupon Name"
                    name="name"
                    rules={[{ required: true, message: 'Please fill coupon name' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Point"
                    name="point"
                    rules={[{ required: true, message: 'Please fill point' }]}
                >
                    <InputNumber min={0} max={1000000} />
                </Form.Item>

                <Form.Item
                    label="Details"
                    name="details"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >

                    <Editor
                        data={details}
                        onChange={(data: string) => {
                            form.setFieldValue('details', data)
                        }}
                    />




                </Form.Item>




                <Form.Item
                    label="Start Date"
                    name="start_date"
                    rules={[{ required: false, message: 'Please field start date' }]}
                >
                    <DatePicker
                        showTime
                        format={'YYYY-MM-DD HH:mm:ss'}
                        onChange={(value, dateString) => {
                            console.log('Selected Time: ', value);
                            console.log('Formatted Selected Time: ', dateString);
                            form.setFieldValue('start_date', value)
                        }}
                        onOk={(value: DatePickerProps['value'] | RangePickerProps['value']) => {
                            console.log('onOk: ', value);
                            form.setFieldValue('start_date', value)
                        }}
                    />

                </Form.Item>

                <Form.Item
                    label="Expired Date"
                    name="expired_date"
                    rules={[{ required: false, message: 'Please field expired date' }]}
                >
                    <DatePicker
                        showTime
                        format={'YYYY-MM-DD HH:mm:ss'}
                        onChange={(value, dateString) => {
                            console.log('Selected Time: ', value);
                            console.log('Formatted Selected Time: ', dateString);
                            form.setFieldValue('expired_date', value)
                        }}
                        onOk={(value: DatePickerProps['value'] | RangePickerProps['value']) => {
                            console.log('onOk: ', value);
                            form.setFieldValue('expired_date', value)
                        }}
                    />

                </Form.Item>

                <Form.Item
                    label="Is Public"
                    name="is_public"
                    valuePropName="checked"
                    rules={[{ required: true, message: 'Please fill Is Public' }]}
                >
                    <Checkbox  >Public</Checkbox>
                </Form.Item>

                <Form.Item
                    label="Is Super Deal"
                    name="is_super_deal"
                    valuePropName="checked"
                    rules={[{ required: true, message: 'Please fill Is Super Deal' }]}
                >
                    <Checkbox  >Super Deal</Checkbox>
                </Form.Item>

                <Form.Item
                    label="Upload Coupon photo"
                    name="photo"
                    extra="Size limit  10 MB."
                >
                    <Upload
                        fileList={fileList}
                        beforeUpload={(file) => {
                            const isLt10M = file.size / 1024 / 1024 < 10;
                            if (!isLt10M) {
                                notification.open({
                                    type: 'warning',
                                    message: 'Image must be smaller than 10MB!',
                                    placement: 'top',
                                });
                                
                                setFileList([])
                                setFile(null);
                                return false; // Prevent the file from being shown in the preview list
                            }
                            setFileList([file])
                            setFile(file);
                            return false; // Allow preview if size is valid
                        }}
                        // beforeUpload={() => false} // Prevent auto upload
                        // onChange={handleFileChange}
                        maxCount={1}
                        onRemove={() => {
                            setFileList([])
                            setFile(null);
                        }}
                        accept="image/*"
                    >
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </Form.Item>


                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
